import { useContext } from "react";

import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import store from "@beeldit/core/services/store";
import {DetailsActionContext} from "@bloonde/billing/invoice-accounts/actions/details/DetailsActionContext";

function useGetByEntity() {
  const { setElement } = useContext(DetailsActionContext);
  const errorHandler = useErrorHandler();

  return (
    id: any,
    entity: string,
    formDefaultValues: any,
    onSuccess: any = (data: any) => {
      return data;
    }
  ) => {
     store(`invoice_accounts/getBy/${id}`, {entity_type: entity})
      .then((response: any) => {
        let data = response.data;
        data = onSuccess(response.data);
        setElement(data.id ? data : formDefaultValues);
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default useGetByEntity;
